import  { useEffect, useState } from "react";
import { HTTPReportS3 } from "./StimulsoftReports";
import { S3_REPORTS_URL } from "../../../utils/constant";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

const HTTPReportViewer = () => {
  const accessToken = localStorage.getItem("accessToken")
  const [reportObject, setReportObject] = useState(null)
  const [searchParams] = useSearchParams()
  let instance = axios.create({
    headers: {
    },
  });

  const getReport = async () => {
    try {
      const filePath = searchParams.get("filePath")
      const { data } = await instance.get(`${S3_REPORTS_URL}${filePath}`)
      setReportObject(data)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getReport()
  }, [])

  useEffect(() => {
    if (reportObject) {
      let report = new HTTPReportS3({
        reportFile: reportObject,
        accessToken: accessToken,
      });
      report.viewer.renderHtml("viewer");
    }
  }, [reportObject])

  return <div id="viewer"></div>;
};

export default HTTPReportViewer;